import {
  createIdentityProvider as apiCreateIdentityProvider,
  deleteIdentityProvider as apiDeleteIdentityProvider,
  getIdentityProviders,
} from "api/identityProviders";
import constate from "constate";
import { useFetchedState } from "hooks/useFetchedState";
import { useCallback } from "react";

const useIdentityProviders = () => {
  const {
    data: identityProviders,
    isLoading,
    loadData: loadIdentityProviders,
    retryAction,
  } = useFetchedState(getIdentityProviders);

  const createIdentityProvider = useCallback(
    async (application: string, metadataUrl: string) => {
      await apiCreateIdentityProvider(application, metadataUrl);
      await retryAction();
    },
    [retryAction],
  );

  const deleteIdentityProvider = useCallback(
    async (id: string) => {
      await apiDeleteIdentityProvider(id);
      await retryAction();
    },
    [retryAction],
  );

  return {
    actions: { createIdentityProvider, deleteIdentityProvider, loadIdentityProviders },
    state: { identityProviders, isLoading },
  };
};

export const [IdentityProvidersProvider, useIdentityProvidersContext] = constate(useIdentityProviders);
